<!-- ── COSTS & EXPENSES ── -->
<app-ip-shell [activeStep]="4">

  <!-- ── FORM COLUMN ── -->
  <div formCol>
    <div class="ip-form-head">
      <div class="ip-form-head__step-meta">Step 04 &middot; Costs &amp; Expenses</div>
      <h1 class="ip-form-head__title">Acquisition costs and running expenses</h1>
      <p class="ip-form-head__subtitle">
        Define your acquisition costs and expected ongoing expenses.
      </p>
    </div>

    <div class="ip-form-body">

      <!-- SDLT Banner -->
      <div class="ip-field">
        <div class="ip-field__head">
          <label class="ip-field__label">Stamp Duty &amp; Land Tax</label>
          <span class="ip-hint"><span class="ip-hint__dot"></span>Auto-calculated · rates as at 2026</span>
        </div>
        <div class="ip-sdlt-callout">
          <div class="ip-sdlt-callout__main">
            <span class="ip-sdlt-callout__title">
              {{ calcData?.BuyerType === 'ftb' ? 'First Time Buyer' : 'Investment / 2nd Property' }}
              &middot;
              {{ calcData?.ForeignBuyer === '1' ? 'Foreign Buyer' : 'UK Resident' }}
            </span>
            <span class="ip-sdlt-callout__sub">
              <ng-container *ngIf="calcData?.BuyerType === 'ftb' && calcData?.ForeignBuyer !== '1'">0% up to £300k · FTB relief rates</ng-container>
              <ng-container *ngIf="calcData?.BuyerType === 'ftb' && calcData?.ForeignBuyer === '1'">FTB relief rates + 2% non-resident surcharge</ng-container>
              <ng-container *ngIf="calcData?.BuyerType !== 'ftb' && calcData?.ForeignBuyer !== '1'">Standard rates + 5% additional dwelling surcharge</ng-container>
              <ng-container *ngIf="calcData?.BuyerType !== 'ftb' && calcData?.ForeignBuyer === '1'">Standard rates + 5% ADS + 2% non-resident surcharge</ng-container>
            </span>
          </div>
          <div class="ip-sdlt-callout__value">£{{ stampDutyLandTax || '0' }}</div>
        </div>
      </div>

      <!-- Acquisition Costs section -->
      <div class="ip-costs-label">Acquisition Costs</div>

      <!-- Processing Fee (only if mortgage) -->
      <div class="ip-field" *ngIf="calcData?.optmortgage!='0'">
        <div class="ip-field__head">
          <label class="ip-field__label" for="loanOriginationFee">Mortgage processing fee</label>
          <span class="ip-hint"><span class="ip-hint__dot"></span>% of loan amount</span>
        </div>
        <div class="ip-input">
          <input
            type="text"
            id="loanOriginationFee"
            class="ip-input__field"
            autocomplete="off"
            placeholder="e.g. 1"
            [(ngModel)]="loanOriginationFee"
            (keyup)="loanOriginationFee=validation.appendPercent($event,loanOriginationFee); onFeeChange()"
            (keypress)="validation.DesimalOnly($event,loanOriginationFee)">

        </div>
      </div>

      <!-- Legal / Solicitor Fees -->
      <div class="ip-field">
        <div class="ip-field__head">
          <label class="ip-field__label" for="legalFees">Legal / solicitor fees</label>
          <span class="ip-hint"><span class="ip-hint__dot"></span>Typical: £1,500–£3,000</span>
        </div>
        <div class="ip-input">
          <span class="ip-input__prefix">£</span>
          <input
            type="text"
            id="legalFees"
            class="ip-input__field"
            autocomplete="off"
            placeholder="e.g. 1,500"
            [(ngModel)]="legalFees"
            (keyup)="legalFees=validation.amountWithComma(legalFees); calcTotals()"
            (keypress)="validation.numberOnly($event)">
        </div>
      </div>

      <!-- Other Expenses -->
      <div class="ip-field">
        <label class="ip-field__label" for="miscelleneousExpense">Other one-off expenses</label>
        <div class="ip-input">
          <span class="ip-input__prefix">£</span>
          <input
            type="text"
            id="miscelleneousExpense"
            class="ip-input__field"
            autocomplete="off"
            placeholder="e.g. 0"
            [(ngModel)]="miscelleneousExpense"
            (keyup)="miscelleneousExpense=validation.amountWithComma(miscelleneousExpense); calcTotals()"
            (keypress)="validation.numberOnly($event)">
        </div>
      </div>

      <!-- Annual Running Costs section -->
      <div class="ip-costs-label">Annual Running Costs</div>

      <!-- Lettings Fee -->
      <div class="ip-field">
        <div class="ip-field__head">
          <label class="ip-field__label" for="letteingManagFee">Lettings &amp; Management fees</label>
        </div>
        <div class="ip-input">
          <input
            type="text"
            id="letteingManagFee"
            class="ip-input__field"
            autocomplete="off"
            placeholder="{{ PropertyLondon == 1 ? '12' : '10' }}"
            [(ngModel)]="letteingManagFee"
            (keyup)="letteingManagFee=validation.appendPercent($event,letteingManagFee); calcTotals()"
            (keypress)="validation.DesimalOnly($event,letteingManagFee)">
          <span class="ip-input__suffix">of rent</span>
        </div>
      </div>

      <!-- Service Charges -->
      <div class="ip-field">
        <div class="ip-field__head">
          <label class="ip-field__label" for="serviceCharges">Service charges p.a.</label>
        </div>
        <div class="ip-input">
          <span class="ip-input__prefix">£</span>
          <input
            type="text"
            id="serviceCharges"
            class="ip-input__field"
            autocomplete="off"
            placeholder="{{ PropertyLondon == 1 ? '3000' : '1000' }}"
            [(ngModel)]="serviceCharges"
            (keyup)="serviceCharges=validation.amountWithComma(serviceCharges); calcTotals()"
            (keypress)="validation.numberOnly($event)">
        </div>
      </div>

    </div><!-- /ip-form-body -->

    <div class="ip-form-actions">
      <button class="ip-btn ip-btn--ghost" type="button" [routerLink]="['/step3']">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline>
        </svg>
        Back
      </button>
      <button class="ip-btn ip-btn--accent" type="button" (click)="next()">
        Calculate Returns
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline>
        </svg>
      </button>
    </div>
  </div><!-- /formCol -->

  <!-- ── RAIL ── -->
  <div rail>
    <div class="ip-rail-summary">
      <div class="ip-rail-summary__head">
        <div class="ip-rail-summary__loc">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle>
          </svg>
          <span class="ip-rail-summary__loc-name">{{ City || 'United Kingdom' }}</span>
        </div>
        <div class="ip-rail-summary__buyer-tag" [class.is-uk]="calcData?.ForeignBuyer!=='1'">
          {{ calcData?.BuyerType === 'ftb' ? 'FTB' : 'Investment' }} &middot; {{ calcData?.ForeignBuyer === '1' ? 'Foreign' : 'UK' }}
        </div>
      </div>

      <div class="ip-rail-summary__body">
        <!-- Property & Financing -->
        <div class="ip-rs-section">
          <div class="ip-rs-section__head">
            <span class="ip-rs-section__label">Property &amp; Financing</span>
          </div>
          <div class="ip-rs-row">
            <span class="ip-rs-row__key">Value · LTV</span>
            <span class="ip-rs-row__val">£{{ calcData?.PropertyValue | number }} · {{ calcData?.loanAmount || '100' }}%</span>
          </div>
          <div class="ip-rs-row" *ngIf="calcData?.optmortgage=='1'">
            <span class="ip-rs-row__key">Type · Term</span>
            <span class="ip-rs-row__val">{{ calcData?.mortgageType == '1' ? 'Interest Only' : 'Repayment' }} · {{ calcData?.mortgageTenure }} yrs</span>
          </div>
          <div class="ip-rs-row" *ngIf="calcData?.optmortgage=='0'">
            <span class="ip-rs-row__key">Financing</span>
            <span class="ip-rs-row__val">All-cash</span>
          </div>
        </div>

        <!-- Currency & Growth -->
        <div class="ip-rs-section">
          <div class="ip-rs-section__head">
            <span class="ip-rs-section__label">Currency &amp; Growth</span>
          </div>
          <div class="ip-rs-row">
            <span class="ip-rs-row__key">Currency · Period</span>
            <span class="ip-rs-row__val">{{ calcData?.homecurrencyText || 'GBP' }} · {{ calcData?.investedTenure }} yrs</span>
          </div>
          <div class="ip-rs-row">
            <span class="ip-rs-row__key">Rental yield</span>
            <span class="ip-rs-row__val">{{ calcData?.rentalYeild }}% p.a.</span>
          </div>
          <div class="ip-rs-row">
            <span class="ip-rs-row__key">Capital growth</span>
            <span class="ip-rs-row__val">{{ calcData?.capitalgrowth }}% p.a.</span>
          </div>
        </div>

        <!-- Costs & Expenses (current step) -->
        <div class="ip-rs-section">
          <div class="ip-rs-section__head">
            <span class="ip-rs-section__label">Acquisition</span>
            <!-- <span class="ip-rs-section__total">£{{ acquisitionTotal || '—' }}</span> -->
          </div>
          <div class="ip-rs-row">
            <span class="ip-rs-row__key">SDLT</span>
            <span class="ip-rs-row__val">£{{ stampDutyLandTax || '—' }}</span>
          </div>
          <div class="ip-rs-row" *ngIf="calcData?.optmortgage!='0' && loanOriginationFee">
            <span class="ip-rs-row__key">Processing ({{ loanOriginationFee }})</span>
            <span class="ip-rs-row__val">£{{ processingFeeAmount }}</span>
          </div>
          <div class="ip-rs-row" *ngIf="legalFees">
            <span class="ip-rs-row__key">Legal</span>
            <span class="ip-rs-row__val">£{{ legalFees }}</span>
          </div>
        </div>

        <div class="ip-rs-section">
          <div class="ip-rs-section__head">
            <span class="ip-rs-section__label">Annual Running</span>
            <!-- <span class="ip-rs-section__total">£{{ runningCostTotal || '—' }}/yr</span> -->
          </div>
          <div class="ip-rs-row" *ngIf="letteingManagFee">
            <span class="ip-rs-row__key">Lettings &amp; Management fees ({{ letteingManagFee }})</span>
            <span class="ip-rs-row__val">of rent</span>
          </div>
          <div class="ip-rs-row" *ngIf="serviceCharges">
            <span class="ip-rs-row__key">Service charges</span>
            <span class="ip-rs-row__val">£{{ serviceCharges }}</span>
          </div>
        </div>
      </div>

      <div class="ip-rail-summary__outlay">
        <div class="ip-rail-summary__outlay-label">Year 1 Total Outlay</div>
        <div class="ip-rail-summary__outlay-value">£{{ year1Total || '—' }}</div>
        <div class="ip-rail-summary__outlay-meta">Deposit + acquisition + Y1 running</div>
      </div>
    </div>
  </div><!-- /rail -->

</app-ip-shell>
